import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ValidatemobileState, validateMobileNumberFeatureKey } from '../reducers/validate-mobile-number.reducer';
import * as mobileValidationReducer from '../reducers/validate-mobile-number.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, ValidatemobileState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE MOBILE SUB STATE
export const getValidateMobileState = createSelector(getAuthState, state => state[validateMobileNumberFeatureKey]);

export const getValidateMobileIsLoading = createSelector(getValidateMobileState, mobileValidationReducer.getIsMobileValidationLoading);

//#region MOBILE VALIDATION
export const getMobileValidationRequest = createSelector(getValidateMobileState, mobileValidationReducer.getMobileValidationRequest);
export const getMobileValidationSuccess = createSelector(getValidateMobileState, mobileValidationReducer.getMobileValidationSuccess);
export const getMobileValidationFailure = createSelector(getValidateMobileState, mobileValidationReducer.getMobileValidationFailure);
//#endregion
